import type { ImageObject, WebPage, WithContext } from "schema-dts";
import { ORG, STRUCTURED_DATA_IDS } from "@/content/_site.config";
import type { Metadata } from "@/content/types";
import { getServiceItemOrCategories } from "../services";

export function buildWebPageFromSpec(seo: Metadata): WithContext<WebPage> {
  const schema: WithContext<WebPage> = {
    "@context": "https://schema.org",
    "@type": seo.pageType ?? "WebPage",
    "@id": STRUCTURED_DATA_IDS.webpage(seo.canonical),
    url: `${ORG.url}${seo.canonical}`,
    name: seo.title,
    ...(seo.description ? { description: seo.description } : {}),
    isPartOf: { "@id": STRUCTURED_DATA_IDS.website },
    publisher: { "@id": STRUCTURED_DATA_IDS.org },
    about: { "@id": STRUCTURED_DATA_IDS.biz },
    inLanguage: "en",
  };

  if (seo.breadcrumb !== false) {
    schema.breadcrumb = {
      "@id": STRUCTURED_DATA_IDS.breadcrumb(seo.canonical),
    } as any;
  }

  if (seo.primaryImage?.src) {
    schema.primaryImageOfPage = {
      "@type": "ImageObject",
      url: `https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME ?? ""}/image/upload/v1757025917/${seo.primaryImage.src}.webp`,
      ...(seo.primaryImage.width ? { width: seo.primaryImage.width } : {}),
      ...(seo.primaryImage.height ? { height: seo.primaryImage.height } : {}),
      ...(seo.primaryImage.alt ? { caption: seo.primaryImage.alt } : {}),
    } as ImageObject;
  }

  if (seo.webpage?.itemList && seo.webpage.itemList.length > 0) {
    const items = getServiceItemOrCategories(seo.webpage.itemList);

    schema.mainEntity = {
      "@type": "ItemList",
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: items.length,
      itemListElement: items.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${ORG.url}${item.href}`,
        name: item.label,
      })),
    };
  }

  return schema;
}
